import React, { Fragment } from 'react';
import { Form, Input, Select, Spin } from 'antd';
import { connect } from 'dva';
import { debounce } from 'lodash-decorators';
import { bankNames } from 'utils/enum/bank-enum.js';

const FormItem = Form.Item;
const { Option } = Select;

@connect(({ BankAccountLinkageFragment, loading }) => ({
  loadingBankBranch: loading.effects['BankAccountLinkageFragment/fetchBankBranch'],
  bankInfo: BankAccountLinkageFragment.bankInfo,
  bankBranchInfo: BankAccountLinkageFragment.bankBranchInfo,
}))
export default class BankAccountLinkageFragment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bankBranchIsDisabled: true,
    };

    this.handleSearchBankInfo = this.handleSearchBankInfo.bind(this);
    this.handleSearchBankBranchInfo = this.handleSearchBankBranchInfo.bind(this);
    this.handleSelectBankName = this.handleSelectBankName.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { errorMsg: oldErrorMsg, bankName: oldBankName } = this.props.bankInfo;
    const { errorMsg: newErrorMsg, bankName: newBankName } = nextProps.bankInfo;

    // 没有匹配到银行
    if (oldBankName !== '' && newBankName === '') {
      nextProps.form.resetFields(['bankBranch']);
      nextProps.form.resetFields(['bankName']);
      return;
    }

    if (oldErrorMsg !== newErrorMsg || oldBankName !== newBankName) {
      this.setState({
        bankBranchIsDisabled: false,
      });

      if (!newErrorMsg) {
        nextProps.form.setFields({
          bankName: {
            value: nextProps.bankInfo.bankName,
            errors: [],
          },
        });
        nextProps.form.resetFields(['bankBranch']);
        nextProps.form.validateFields(['bankName']);
      } else {
        nextProps.form.setFields({
          bankName: {
            errors: [new Error(newErrorMsg)],
          },
        });
      }
    }
  }

  // 重置数据
  componentWillUnmount() {
    this.props.dispatch({
      type: 'BankAccountLinkageFragment/resetState',
    });
  }

  // 当银行卡失去焦点时，根据银行卡号获取其所属银行
  handleSearchBankInfo(e) {
    const bankNo = e.target.value;

    if (!bankNo) {
      return;
    }

    this.props.dispatch({
      type: 'BankAccountLinkageFragment/searchBankInfo',
      bankNo,
    });
  }

  // 根据所属银行名字和已输入所属支行信息查询所属支行列表
  @debounce(800)
  handleSearchBankBranchInfo(bankBranchName) {
    if (!bankBranchName) {
      return;
    }

    const { dispatch, bankInfo: { bankName } } = this.props;

    const bankNameSelect = this.props.form.getFieldValue('bankName');

    // 清空支行数据
    dispatch({
      type: 'BankAccountLinkageFragment/saveBankBranchInfo',
      bankBranchInfo: [],
    });

    dispatch({
      type: 'BankAccountLinkageFragment/fetchBankBranch',
      bankName: bankName || bankNameSelect,
      bankBranchName,
    });
  }

  handleSelectBankName(value) {
    const { form, dispatch } = this.props;
    form.resetFields(['bankBranch']);

    // 清空支行数据
    dispatch({
      type: 'BankAccountLinkageFragment/saveBankBranchInfo',
      bankBranchInfo: [],
    });

    if (value) {
      this.setState({
        bankBranchIsDisabled: false,
      });
    } else {
      this.setState({
        bankBranchIsDisabled: true,
      });
    }
  }

  render() {
    const {
      newFormItemLayout,
      bankInfo: { bankName, errorMsg },
      loadingBankBranch,
      bankBranchInfo,
      form: { getFieldDecorator },
    } = this.props;
    const { bankBranchIsDisabled } = this.state;

    return (
      <Fragment>
        <FormItem {...newFormItemLayout} label="开户账号">
          {getFieldDecorator('bankNo', {
            rules: [{ required: true, message: '请输入开户账号' }],
          })(<Input placeholder="请输入" onBlur={this.handleSearchBankInfo} />)}
        </FormItem>

        {bankName !== '' && (
          <FormItem {...newFormItemLayout} label="所属银行">
            {getFieldDecorator('bankName', {
              initialValue: bankName,
              rules: [{ required: true, message: errorMsg || '输入开户账号后，自动匹配所属银行' }],
            })(<Input placeholder="输入开户账号后，自动匹配所属银行" disabled />)}
          </FormItem>
        )}

        {bankName === '' && (
          <FormItem {...newFormItemLayout} label="所属银行">
            {getFieldDecorator('bankName', {
              initialValue: bankName,
              rules: [{ required: true, message: '请选择所属银行' }],
            })(
              <Select showSearch placeholder="请选择" onSelect={this.handleSelectBankName}>
                {bankNames.map(d => <Option key={d}>{d}</Option>)}
              </Select>
            )}
          </FormItem>
        )}

        <FormItem {...newFormItemLayout} label="所在支行">
          {getFieldDecorator('bankBranch', {
            rules: [{ required: true, message: '请输入所在支行' }],
          })(
            <Select
              labelInValue
              showSearch
              placeholder="请选择"
              notFoundContent={loadingBankBranch ? <Spin size="small" /> : '请输入关键字进行搜索'}
              onSearch={this.handleSearchBankBranchInfo}
              filterOption={false}
              disabled={bankBranchIsDisabled}
            >
              {bankBranchInfo.map(d => <Option key={d.bankCode}>{d.fullBankName}</Option>)}
            </Select>
          )}
        </FormItem>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/BankAccountLinkageFragment/Index.js